import $ from 'jquery';
import FormatUtils from 'application/format_utils';
import noUiSlider from 'nouislider';

function configureSlider($slider, $placeholder, map, sliderRange, startValue) {
  const range = sliderRange;

  if ($slider.length) {
    const slider = $slider[0];
    const blurNonSlider = function blurNonSlider() {
      document.activeElement.blur();
    };
    const updateValue = function updateValue(values) {
      $('#interest_maximum_value').attr('data-interacted', 'yes').val(values);
      $placeholder.text(`${FormatUtils.currency(values, 'R$', 0)}/mês`);
    };
    const updateOthers = function updateOthers(values) {
      slider.noUiSlider.set(values);
    };
    const releaseSlider = function releaseSlider() {
      $(slider).trigger('releaseslider');
    };
    const steps = [];
    let currMin = 100;

    for (const step in map) { // eslint-disable-line
      const ref = map[step];
      const max = ref[1];

      while (currMin < max) {
        currMin += parseInt(step, 10);
        steps.push(currMin);
      }
    }
    const percentStep = 100 / steps.length;
    let percent = 0;
    for (let i = 0, len = steps.length; i < len; i += 1) {
      const step = steps[i];
      percent += percentStep;
      range[`${percent.toFixed(2)}%`] = step;
    }
    noUiSlider.create(slider, {
      start: $('#interest_maximum_value').val() || startValue,
      range,
      snap: true,
    });
    $(slider).data('noUiSlider', slider.noUiSlider);
    slider.noUiSlider.on('start', blurNonSlider);
    slider.noUiSlider.on('slide', updateValue);
    slider.noUiSlider.on('change', updateOthers);
    slider.noUiSlider.on('end', releaseSlider);
    $placeholder.first().text(`${FormatUtils.currency(slider.noUiSlider.options.start, 'R$', 0)}/mês`);
  }

  if ($('#interest_maximum_value[data-interacted="no"]').length) {
    $('#interest_maximum_value').val('');
  }
}

export const initSlider = (config = {}) => {
  const $slider = config.slider || $('.value-slider, .js-price-slider');
  const $placeholder = config.placeholder || $('.value-slider-placeholder, .js-price-value');
  const startValue = config.startValue || 10000;

  const map = config.map || {
    25: [0, 300],
    50: [300, 1000],
    100: [1000, 2000],
    500: [2000, 10000],
  };
  const range = config.range || {
    min: 100,
    max: 10000,
  };

  configureSlider($slider, $placeholder, map, range, startValue);
};

export const initSliderPosgrad = (config = {}) => {
  const $slider = config.slider || $('.value-pos-slider, .js-posgrad-price-slider');
  const $placeholder = config.placeholder || $('.value-posgrad-slider-placeholder, .js-pos-price-value');
  const startValue = config.startValue || 10000;

  const map = config.map || {
    25: [0, 600],
    50: [600, 1000],
    100: [1000, 2000],
    500: [2000, 5000],
    5000: [5000, 10000],
  };
  const range = config.range || {
    min: 100,
    max: 10000,
  };

  configureSlider($slider, $placeholder, map, range, startValue);
};

export const initMultipleSlider = () => {
  if ($('.value-slider').length) {
    const sliders = $('.value-slider');
    const blurNonSlider = function blurNonSlider() {
      document.activeElement.blur();
    };
    const updateValue = function updateValue(values) {
      $('.interest_max_val').attr('data-interacted', 'yes').val(values);
      $('.value-slider-placeholder').text(`${FormatUtils.currency(values, 'R$', 0)}/mês`);
    };
    const updateOthers = function updateOthers(values) {
      sliders.each(function each() {
        this.noUiSlider.set(values);
      });
    };
    const map = {
      25: [0, 300],
      50: [300, 1000],
      100: [1000, 2000],
      500: [2000, 10000],
    };
    const range = {
      min: 100,
      max: 10000,
    };
    const steps = [];
    let currMin = 100;
    for (const step in map) { // eslint-disable-line
      const ref = map[step];
      const max = ref[1];

      while (currMin < max) {
        currMin += parseInt(step, 10);
        steps.push(currMin);
      }
    }
    const percentStep = 100 / steps.length;
    let percent = 0;
    for (let i = 0, len = steps.length; i < len; i += 1) {
      const step = steps[i];
      percent += percentStep;
      range[`${percent.toFixed(2)}%`] = step;
    }
    for (let j = 0, len1 = sliders.length; j < len1; j += 1) {
      const slider = sliders[j];
      noUiSlider.create(slider, {
        start: $('.interest_max_val').first().val() || 10000,
        range,
        snap: true,
      });
      $(slider).data('noUiSlider', slider.noUiSlider);
      slider.noUiSlider.on('start', blurNonSlider);
      slider.noUiSlider.on('slide', updateValue);
      slider.noUiSlider.on('change', updateOthers);
      $('.value-slider-placeholder').each(function each() {
        $(this).text(`${FormatUtils.currency(slider.noUiSlider.options.start, 'R$', 0)}/mês`);
      });
    }
  }
  if ($('.interest_max_val[data-interacted="no"]').length) {
    $('.interest_max_val').val('');
  }
};
